import React,{
	useRef, 
	useState, 
	useEffect,
	useContext
}										from "react";
import { 
	Form, 
	Col, 
	Row,
	Button, 
	Spinner,
	Alert
}										from "react-bootstrap";
import Select							from "react-select";
import EditableRange					from "../components/EditableRange";
import atlasApi							from "../utils/atlasapi";
import authApi							from "../utils/authApi";
import { 
	X, 
	Trash, 
	Angle, 
	CaretDown,
	Warning
}										from "@phosphor-icons/react";
import ColorPicker						from "../components/ColorPicker";
import LayerDrawing						from "../classes/LayerDrawing";
import {
	number_format,
	format_power,
	processOwnersAndLands
}										from "../utils/functions";


import globalContext					from "../utils/globalContext";



export default function CompensationPanel({
	setup,
	tc,
	onClose,
	onChange,
	onSaveClose
		
}) {
	
	const [values,setValues]					= useState(false); 
	const [price,setPrice]						= useState(false); 
	const [aep,setAep]							= useState(false); 
	const [total,setTotal]						= useState(tc.scenario?.compensationInfo?.totalAfterCap ?? 0); 
	const [loading,setLoading]					= useState(false); 
	const context								= useContext(globalContext);
	const wrp									= useRef(null);
	const timedFunc								= useRef(null);
	
	
	useEffect(()=>{
		getData();
	},[]);

	useEffect(()=>{
		const t = tc.scenario?.compensationInfo?.totalAfterCap;
		if(t !== undefined)
			setTotal(t);
	},[tc.scenario?.compensationInfo?.totalAfterCap]);
	
	const handleToggler = (e) => {
		
		wrp.current.classList.toggle("open");
	}
	
	const handleInput = (e, update) => {
		var original = e.target.value.replace(",", ".");
		
		var values = {
			aep,
			price
		}
		values[e.target.name] = e.target.value;

		if(!isNaN(original)){
			update(original);
			handleOnChange(values);
			e.target.classList.remove("border-danger");
		}
		else {
			update(original);
			clearTimeout(timedFunc.current);
			e.target.classList.add("border-danger");
		}
	}
	const handleReset = () => {
		
		setAep(values.default_aep);
		setPrice(values.default_kwh_price);
		
		handleOnChange({
			price: values.default_kwh_price,
			aep: values.default_aep
		});

	}
	const handleOnChange = (values) => {


		clearTimeout(timedFunc.current);
		timedFunc.current = setTimeout(()=>{
			setLoading(true);
			atlasApi.getScenario(tc.scenario.projectid, tc.scenario.scenario_id, null, context.getters.workMode.value, values.price, values.aep).then((res)=>{
				
				if(res && res.scenario_id !== undefined){
					var owners = res.landowners;
					var geodata = res.properties;
					processOwnersAndLands(owners, geodata);
					context.setters.setOwners(owners);
					setTotal(res.compensationInfo.totalAfterCap);
				}
				setLoading(false);
			});
		}, 1000);
		
		
	}
	const getData = ()=>{ 
		
		Promise.all([atlasApi.getToken()])
		.then((res) => {
			return Promise.all([authApi.getUser()]);
		})
		.then((res) => {
	
			const dataRequests = [
				atlasApi.getCompensation(tc.scenario.projectid, tc.scenario.scenario_id)
			];
			return Promise.all(dataRequests);
		})
		.then((res)=>{
			const newS = res[0];
			setValues(newS);
			setPrice(newS.kwh_price ?? newS.default_kwh_price);
			setAep(newS.aep ?? newS.default_aep);
			setTotal(tc.scenario?.compensationInfo?.totalAfterCap ?? 0);
			
		}).catch((e)=>{
			console.log(e);
			
		});
		return;

	};	
	var power
	if(aep)
		power = format_power(aep * 1000).split(" ");
	else
		power = [0,"GWh"];

	return (
		<>
		<div className="compensation-panel container g-5" ref={wrp}>
	
			{!loading && <div className="toggler" onClick={handleToggler}><CaretDown size={16} weight="bold" color="#5E89B1" /></div> }
			{loading && <div className="toggler" onClick={handleToggler}><Spinner animation="border" variant="info" /></div>}
			
			{!!values &&
			<Row className="basic">
				<div className="sep"><b>{price}</b> {values.currency}/KWh</div>
				<div className="sep"><b>{power[0]}</b> {power[1]}</div>
				<div>{values.currency} <b>{number_format(total)}</b></div>
				<div></div>
			</Row>	
			}
			<div className="editable">
				<Row className="mb-2">
					<Col><b>Adjust compensation</b></Col>
				</Row>
				<Row className="mb-3">
					<Form.Group as={Col} md="6">
						<Form.Label>Price per KWh</Form.Label>
						<Form.Control type="text" name="price" value={price} onInput={(e)=>{handleInput(e, setPrice)}} />
					</Form.Group>
					<Form.Group as={Col} md="6">
						<Form.Label>AEP (GWh)</Form.Label>
						<Form.Control type="text" name="aep" value={aep} onInput={(e)=>{handleInput(e, setAep)}} />
					</Form.Group>
				</Row>
				{!!tc.scenario.compensationInfo && 
				<Row className="mb-3">
					<Col md="8" className="pe-0">Total compensation: <b>{values.currency} {number_format(total)} </b></Col>
					<Col md="4" className="ps-0 text-end"><Button variant="link" className="m-0 p-0" onClick={handleReset}>Reset to defaults</Button></Col>
				</Row>
				}
			</div>
		</div>  
		{!!tc.scenario.compensationInfo && tc.scenario.compensationInfo.capped &&
			<div className="compensation-capped container">
				<Alert variant="warning" className="with-icon m-0 my-3">
					<div className="icon">
						<Warning size={16} weight="bold" color="#B54708" />
					</div>
					<div className="text">
						<b>Warning:</b> The total compensation has been capped to a maximum of 2% of total revenue. Total compensation was originally <b>{number_format(tc.scenario.compensationInfo.totalBeforeCap)} {values.currency}. </b>
					</div>

				</Alert>

			</div>
		}
		</>
	);
	

}